import { SelectGroup } from "@/components/Pages/Scout/elements/MultiSelectListPopover/GroupPopover/types";

export const activitySelectGroupItems: SelectGroup[] = [
  {
    item: {
      label: "学問",
      value: "学問"
    },
    subItems: [
      {
        label: "首席",
        value: "首席",
        parent: "学問"
      },
      {
        label: "奨学金の無償提供",
        value: "奨学金の無償提供",
        parent: "学問"
      },
      {
        label: "学会（国内）発表経験",
        value: "学会（国内）発表経験",
        parent: "学問"
      },
      {
        label: "学会（国際）発表経験",
        value: "学会（国際）発表経験",
        parent: "学問"
      },
      {
        label: "表彰経験",
        value: "表彰経験",
        parent: "学問"
      },
      {
        label: "ゼミ設立経験",
        value: "ゼミ設立経験",
        parent: "学問"
      },
      {
        label: "ゼミ幹部",
        value: "ゼミ幹部",
        parent: "学問"
      },
      {
        label: "ゼミ長",
        value: "ゼミ長",
        parent: "学問"
      }
    ]
  },
  {
    item: {
      label: "留学・海外滞在",
      value: "留学・海外滞在"
    },
    subItems: [
      {
        label: "留学（1ヶ月未満）",
        value: "留学（1ヶ月未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "留学（1ヶ月以上〜3ヶ月未満）",
        value: "留学（1ヶ月以上〜3ヶ月未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "留学（3ヶ月以上〜半年未満）",
        value: "留学（3ヶ月以上〜半年未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "留学（半年以上〜1年未満）",
        value: "留学（半年以上〜1年未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "留学（1年以上）",
        value: "留学（1年以上）",
        parent: "留学・海外滞在"
      },
      {
        label: "海外滞在（1年未満）",
        value: "海外滞在（1年未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "海外滞在（1年以上〜3年未満）",
        value: "海外滞在（1年以上〜3年未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "海外滞在（3年以上〜5年未満）",
        value: "海外滞在（3年以上〜5年未満）",
        parent: "留学・海外滞在"
      },
      {
        label: "海外滞在（5年以上〜10年未満）",
        value: "海外滞在（5年以上〜10年未満）",
        parent: "留学・海外滞在"
      }
    ]
  },
  {
    item: {
      label: "課外活動",
      value: "課外活動"
    },
    subItems: [
      {
        label: "大学体育会",
        value: "大学体育会",
        parent: "課外活動"
      },
      {
        label: "中・高運動部",
        value: "中・高運動部",
        parent: "課外活動"
      },
      {
        label: "大学文化系部活",
        value: "大学文化系部活",
        parent: "課外活動"
      },
      {
        label: "中・高文化系部活",
        value: "中・高文化系部活",
        parent: "課外活動"
      },
      {
        label: "表彰経験",
        value: "表彰経験",
        parent: "課外活動"
      },
      {
        label: "主将・副主将経験",
        value: "主将・副主将経験",
        parent: "課外活動"
      },
      {
        label: "全国大会出場",
        value: "全国大会出場",
        parent: "課外活動"
      },
      {
        label: "サークルメンバー",
        value: "サークルメンバー",
        parent: "課外活動"
      },
      {
        label: "サークル幹部",
        value: "サークル幹部",
        parent: "課外活動"
      },
      {
        label: "サークル代表",
        value: "サークル代表",
        parent: "課外活動"
      },
      {
        label: "サークル設立経験",
        value: "サークル設立経験",
        parent: "課外活動"
      },
      {
        label: "学生団体メンバー",
        value: "学生団体メンバー",
        parent: "課外活動"
      },
      {
        label: "学生団体幹部",
        value: "学生団体幹部",
        parent: "課外活動"
      },
      {
        label: "学生団体代表",
        value: "学生団体代表",
        parent: "課外活動"
      },
      {
        label: "学生団体設立経験",
        value: "学生団体設立経験",
        parent: "課外活動"
      },
      {
        label: "ボランティア",
        value: "ボランティア",
        parent: "課外活動"
      },
      {
        label: "国際派遣",
        value: "国際派遣",
        parent: "課外活動"
      },
      {
        label: "ビジコン出場",
        value: "ビジコン出場",
        parent: "課外活動"
      },
      {
        label: "ビジコン優勝",
        value: "ビジコン優勝",
        parent: "課外活動"
      },
      {
        label: "NPO・NGO",
        value: "NPO・NGO",
        parent: "課外活動"
      },
      {
        label: "起業",
        value: "起業",
        parent: "課外活動"
      }
    ]
  },
  {
    item: {
      label: "資格",
      value: "資格"
    },
    subItems: [
      {
        label: "日商簿記1級",
        value: "日商簿記1級",
        parent: "資格"
      },
      {
        label: "日商簿記2級",
        value: "日商簿記2級",
        parent: "資格"
      },
      {
        label: "公認会計士",
        value: "公認会計士",
        parent: "資格"
      },
      {
        label: "税理士",
        value: "税理士",
        parent: "資格"
      },
      {
        label: "行政書士",
        value: "行政書士",
        parent: "資格"
      },
      {
        label: "弁護士",
        value: "弁護士",
        parent: "資格"
      },
      {
        label: "弁理士",
        value: "弁理士",
        parent: "資格"
      },
      {
        label: "ファイナンシャル・プランナー",
        value: "ファイナンシャル・プランナー",
        parent: "資格"
      },
      {
        label: "宅地建物取引士",
        value: "宅地建物取引士",
        parent: "資格"
      },
      {
        label: "経営学修士（MBA）",
        value: "経営学修士（MBA）",
        parent: "資格"
      },
      {
        label: "秘書検定",
        value: "秘書検定",
        parent: "資格"
      },
      {
        label: "国家公務員Ⅰ種",
        value: "国家公務員Ⅰ種",
        parent: "資格"
      },
      {
        label: "地方公務員上級",
        value: "地方公務員上級",
        parent: "資格"
      },
      {
        label: "教員試験",
        value: "教員試験",
        parent: "資格"
      },
      {
        label: "薬剤師",
        value: "薬剤師",
        parent: "資格"
      },
      {
        label: "1級建築士",
        value: "1級建築士",
        parent: "資格"
      },
      {
        label: "2級建築士",
        value: "2級建築士",
        parent: "資格"
      },
      {
        label: "管理栄養士",
        value: "管理栄養士",
        parent: "資格"
      },
      {
        label: "中小企業診断士",
        value: "中小企業診断士",
        parent: "資格"
      },
      {
        label: "アクチュアリー",
        value: "アクチュアリー",
        parent: "資格"
      },
      {
        label: "ITパスポート",
        value: "ITパスポート",
        parent: "資格"
      },
      {
        label: "マイクロソフトオフィススペシャリスト（MOS）",
        value: "マイクロソフトオフィススペシャリスト（MOS）",
        parent: "資格"
      },
      {
        label: "基本情報技術者",
        value: "基本情報技術者",
        parent: "資格"
      },
      {
        label: "応用情報技術者",
        value: "応用情報技術者",
        parent: "資格"
      },
      {
        label: "情報セキュリティスペシャリスト",
        value: "情報セキュリティスペシャリスト",
        parent: "資格"
      },
      {
        label: "その他",
        value: "その他",
        parent: "資格"
      }
    ]
  },
  {
    item: {
      label: "活動実績なし",
      value: "活動実績なし"
    },
    subItems: []
  }
];
